import { useProjectCoverStore } from '@/modules/Project/useProjectCoverStore'
import type { ProjectInList } from '@/modules/Projects/useProjects'
import { nonNullable } from '@/shared/utils/typeAssertions'
import { captureException } from '@sentry/vue'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'

const COVERS = [
  'https://dbzsnr1fgd4ik.cloudfront.net/cover-gradient-1.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/cover-gradient-2.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/cover-gradient-3.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/cover-gradient-4.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/cover-gradient-5.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/cover-gradient-6.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-35.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-73.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-96.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-158.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-198.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-212.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-281.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-298.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-301.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-322.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-371.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-372.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-438.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-439.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-475.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-527.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-529.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-545.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-548.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-597.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-617.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-633.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-813.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-900.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-959.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-989.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-1-996.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-98.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-101.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-219.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-229.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-263.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-317.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-430.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-454.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-456.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-469.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-484.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-486.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-490.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-532.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-577.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-597.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-603.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-627.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-632.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-688.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-691.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-820.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-925.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-926.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-2-946.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-34.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-44.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-97.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-149.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-151.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-161.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-179.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-197.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-293.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-341.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-342.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-422.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-433.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-567.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-572.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-581.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-591.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-598.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-647.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-676.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-704.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-769.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-843.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-851.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-882.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-899.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-945.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-966.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-3-998.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-13.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-113.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-120.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-132.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-244.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-316.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-354.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-359.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-362.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-391.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-395.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-398.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-572.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-648.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-689.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-880.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-886.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-969.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-4-991.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-6.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-263.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-284.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-302.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-412.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-471.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-483.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-529.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-547.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-578.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-605.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-752.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-776.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-818.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-825.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-839.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-845.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-860.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-898.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-910.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-5-960.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-30.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-66.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-84.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-92.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-123.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-194.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-261.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-341.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-400.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-473.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-527.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-540.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-602.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-607.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-703.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-707.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-744.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-764.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-807.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-854.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-869.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-6-887.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-8.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-22.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-45.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-49.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-223.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-263.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-273.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-306.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-316.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-328.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-378.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-420.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-437.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-503.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-504.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-515.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-613.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-619.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-651.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-686.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-755.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-822.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-860.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-7-865.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-1.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-12.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-139.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-211.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-307.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-402.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-478.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-557.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-578.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-588.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-592.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-616.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-684.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-693.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-707.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-741.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-778.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-821.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-850.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-879.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-8-989.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-63.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-76.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-83.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-116.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-128.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-327.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-358.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-361.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-388.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-542.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-565.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-572.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-644.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-653.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-673.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-708.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-753.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-773.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-819.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-832.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-836.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-837.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-864.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-877.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-935.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-973.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-9-982.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-120.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-212.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-234.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-247.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-296.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-402.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-495.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-527.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-548.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-566.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-725.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-745.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-756.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-767.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-769.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-817.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-901.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-918.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-940.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-976.png',
  'https://dbzsnr1fgd4ik.cloudfront.net/meshy-gradient-10-980.png',
]

/** Returns information about the given project's cover image. */
export function useProjectCover(project: MaybeRefOrGetter<ProjectInList>) {
  const projectCoverStore = useProjectCoverStore()
  const projectId = computed(() => nonNullable(toValue(project)).id)
  const hasError = computed(() => projectCoverStore.errors.has(projectId.value))
  const isUploading = computed(() => projectCoverStore.uploading.has(projectId.value))

  function setError(hasError: boolean) {
    if (hasError) {
      projectCoverStore.errors.add(projectId.value)
    } else {
      projectCoverStore.errors.delete(projectId.value)
    }
  }

  function setUploading(isUploading: boolean) {
    if (isUploading) {
      projectCoverStore.uploading.add(projectId.value)
    } else {
      projectCoverStore.uploading.delete(projectId.value)
    }
  }

  /**
   * Uploads a file as a project cover, managing state during the process
   */
  async function uploadFileAsProjectCover(file: File) {
    await projectCoverStore.uploadFileAsProjectCover(project, file)
  }

  const largeImageURL = computed(() => projectCoverStore.getCoverImageUrl(project, 'high'))
  const smallImageURL = computed(() => projectCoverStore.getCoverImageUrl(project, 'low'))

  return {
    hasError,
    isUploading,
    setError,
    setUploading,
    uploadFileAsProjectCover,
    largeImageURL,
    smallImageURL,
  }
}

export async function fetchCoverFile(url: string): Promise<File | null> {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    return new File([blob], 'cover-auto-generated.png', { type: 'image/png' })
  } catch (error) {
    // In case of CORS errors or moved files, we don't want to kill whatever
    // process is calling this function. We just want to log the error and
    // return null.
    captureException(error)
    return null
  }
}

export function getRandomProjectCoverURL(): string {
  const randomIndex = Math.floor(Math.random() * COVERS.length)
  return nonNullable(COVERS[randomIndex])
}
